import React, {useState, useEffect, useMemo, useRef} from "react";
import {toastr} from 'react-redux-toastr';
import general_fetch from '../../utils/fetch';
import {FormGroup, Button, Form, Input, Modal, InputGroupAddon, InputGroupText, InputGroup, Badge, Card, CardBody, CardHeader, CardFooter, Col, Table, Row, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import Submit from "../../utils/Submit";
import DeleteNotification from "../DeleteNotification";
import { confirmAlert } from "react-confirm-alert";
import FindOrgsByEmail from "../FindOrgsByEmail";
import { Checkbox, DatePicker, Tooltip as AntTooltip } from "antd";
import dayjs from 'dayjs';
import { CspModal, CspModalBody, CspModalFooter, CspModalHeader } from "../CspModal";
import { date_string } from "../../utils/date_string";
import EditTdsModal, { derive_tds_percentage } from "../EditTdsModal/index.jsx";
import InlineTdsAdjuster from "../InlineTdsAdjuster/index.jsx";
import ZohoDetailsMissingModal from "../ZohoDetailsMissingModal/index.jsx";
import { build_estimate_body, is_dump_unavailable_error } from "../ZohoDetailsMissingModal/zoho_gst_match";
import ZohoGstMismatchModal from "../ZohoGstMismatchModal/index.jsx";
import { derive_download_route } from "../ZohoDetailsMissingModal/gst_mismatch";
import { market_of_store } from "../ZohoDetailsMissingModal/gst_validation";
import { payment_gateway_options } from "./payment_gateway_options";
import AccountStatementModal from "../AccountStatementModal/index.jsx";

// The ledger-backed account statement (csp/account_statement, CS admin only on the backend) is
// shown to these logins only while it is validated on stage; widen the list once signed off.
const ACCOUNT_STATEMENT_ALLOWED_EMAILS = ['bhargav.siva@infurnia.com'];
const can_view_account_statement = (user_details) => !!(user_details && user_details.email && ACCOUNT_STATEMENT_ALLOWED_EMAILS.includes(String(user_details.email).toLowerCase()) && user_details.role && user_details.role.store && user_details.role.store.includes('customer_success_admin'));

const submit = (yes_del, no_del, message, button_name, Custom_modal) => {
	confirmAlert({
	  title: 'Confirm to submit',
	  message: message,
	  customUI: ({ onClose }) => {
		return (
		  Custom_modal ?
			<div>
			  <Custom_modal yes_del={yes_del} no_del={no_del} onClose={onClose} text={message} button_name={button_name} />
			</div>
			:
			<div className='custom-ui'>
			  <DeleteNotification yes_del={yes_del} no_del={no_del} onClose={onClose} text={message} button_name={button_name} />
			</div>
		);
	  }
	});
}


// [ST-4040] manual dues reminder is rolled out to these CSP users only
const SEND_DUES_REMINDER_EMAILS = ['bhargav.siva@infurnia.com'];
const SEND_DUES_REMINDER_ERRORS = {
	USAGE_STATEMENT_PDF_MISSING: 'Usage statement PDF is still missing, regenerate it first',
	DUE_DATE_PASSED: 'Due date has passed, there is no reminder to send',
	BILLING_MAILING_DISABLED: 'Billing mails are disabled for this org',
	NO_DUE_ORDER: 'This org has no postpaid due',
	TOO_MANY_ORDERS: 'This org has more than one postpaid due',
};
// [ST-3991] backend refusal codes not in the error registry; the rest arrive as readable messages
const RECALCULATE_DUE_ERRORS = {
	TOO_MANY_ORDERS: 'This org has more than one postpaid due',
};

const generate_badge = (text, color) => (
	<Badge color={color} className="mb-0" style={{display: "inline-block", marginLeft:"auto", textTransform:'capitalize'}}><h3 style={{fontSize:'15px'}} className="mb-0">{text}</h3></Badge>
)

const RemoveOnboardingFeeModal = ({open, toggle, store_id, store_info, fetch_store_info, dues, fetch_dues, set_page_loader}) => {
	const [ selected_addons, set_selected_addons ] = useState({});
	const [ re_render, set_re_render ] = useState(false);
	const forceReRender = () => set_re_render(!re_render)
	
	const onClickRemoveOnboardingFee = async() => {
		try{
			let body = {};
			body["customer_store_id"] = store_id
			body["add_on_ids"] = Object.keys(selected_addons).filter(x => selected_addons[x])
			set_page_loader(true, "Please Wait")
			let resp = await general_fetch({url: 'csp/remove_onboarding_fees_from_addons', body})
			fetch_dues()
			toggle()
		}catch(err){
			toastr.error("Could not remove the onboarding fee. Please try again in sometime")
		}

		set_page_loader(false, "")
	}

	return(
		<>
			<Modal isOpen={open} size='md' toggle={toggle}>
				<ModalHeader toggle={toggle}>Remove Onboarding Fee</ModalHeader>
				<ModalBody>
				{ 
					dues && dues[0] && dues[0].dues_details && dues[0].dues_details.add_ons && dues[0].dues_details.add_ons.length ? dues[0].dues_details.add_ons.map(addon => (
						<div>
							<Checkbox checked={selected_addons[addon.add_on_id]} onClick={() => {selected_addons[addon.add_on_id] = !selected_addons[addon.add_on_id]; forceReRender()}}>
								{addon.name}
							</Checkbox>
						</div>
					))
					:''
				}
				</ModalBody>
				<ModalFooter>
					<Button className="btn-sm" color="primary" onClick={onClickRemoveOnboardingFee}>Remove Onboarding Fee</Button>
				</ModalFooter>
			</Modal>
		</>
	)
}

const UpdateExtraUsers = ({open, toggle, store_info, fetch_store_info, fetch_dues, set_page_loader}) => {

	const [users, set_users] = useState();

	useEffect(() => {
		
	}, [store_info]);

	const onClick_handleClose = () => {
		set_users()
		toggle()
	}

	const onclick_submit = async() => {
		try{
			let customer_store_id = window.location.pathname.split('/')[3]
			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({url:'csp/update_future_excess_users_in_dues', body:{customer_store_id, excess_users: Number(users)}})
			set_page_loader(false, 'Please wait...')
			toastr.success('Successfully updated excess users')
			fetch_store_info()
			fetch_dues()
			onClick_handleClose()
		}catch(err){
			set_page_loader(false, 'Please wait...')
			toastr.error('Something went wrong, Please try again')
			console.error(err)
		}
	}

	return(
		<Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onClick_handleClose}>
			<div className="modal-header  bg-gradient-white">
				<h4 className="modal-title" style={{}}>Update extra users</h4>
				<button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={onClick_handleClose}>
				<span aria-hidden={true}>×</span>
				</button>
			</div>
			<div className="modal-body  bg-gradient-secondary" style={{fontSize:'14px'}}>
				<Row>
                    <Col md="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
							Extra Users
                        </label>
                        <Input name="credits" className="form-control-alternative" type="number" placeholder='Type...' value={users} onChange={(e) => set_users(e.target.value)} />
                      </FormGroup>
                    </Col>
                  </Row>
				<Button color='primary' onClick={() => submit(onclick_submit, ()=>{}, 'This action will re-generate the Org dues, are you sure you want to proceed?', '','')}>Submit</Button>
			</div>
		</Modal>
	)
}

const MakePayment = ({ open, toggle, store_id, store_info, active_due, user_details, has_pending_offline_payment, fetch_dues, set_page_loader}) => {
    const [comment, set_comment] = useState('');
    const [credits, set_credits] = useState(0);
    // const [credit_type, set_credit_type] = useState('');
    // const alert = useAlert()
    // Ref to the inline TDS adjuster — record flushes its pending TDS (applies it) first.
    const tds_ref = useRef(null);

    const active_order_id = active_due && active_due.id;

    const assign_credits = async () => {
      if(comment.trim()){
        // Apply any pending inline-TDS change (record-time, via flush) before recording, so
        // the recorded amount matches the post-TDS total. If the TDS set fails, the adjuster
        // already showed a descriptive error — abort the record.
        let flushed = { applied: false };
        if (tds_ref.current) {
            try {
                flushed = await tds_ref.current.flush();
            } catch (err) {
                return;
            }
        }
        const amount_to_record = (flushed && flushed.applied && flushed.order && flushed.order.total != null)
            ? Number(flushed.order.total)
            : credits;
        try {
            // var resp = await assign_free_credits({ comment, credits, customer_store_id: store_id, account_type: credits_account });
            try{
				set_page_loader(true, 'Please wait...');
              var resp = await general_fetch({url: 'billing/order/mark_manual_payment', body:{customer_store_id:store_id, amount:amount_to_record, comment:comment, order_id:active_order_id, currency: store_info && store_info.market && store_info.market == 'international' ? 'USD' : 'INR'}});
			  set_page_loader(false);
              // console.log(resp);
            //   fetch_store_info()
              toastr.success('Payment Recorded Successfully')
              fetch_dues()

            }
            catch(err){
				set_page_loader(false);
              // alert.error("Something went Wrong")
              toastr.error('Something went wrong')
              // If the TDS was applied by flush() but the record then failed, refetch so the
              // dues reflect the persisted TDS (otherwise the next open compares against stale
              // pre-TDS values and a revert/retry can mismatch the backend total).
              if (flushed && flushed.applied) fetch_dues()
            }
            // var resp = await general_fetch({url: 'billing/order/assign_free_credits', body:{customer_store_id:store_id, credits:credits, note:comment}});
            // console.log(resp);
            // fetch_store_info()
            toggle();
        } catch(err) {
            console.log(err);
        }
      }else{
		set_page_loader(false);
        toastr.error('Note is Mandatory')
      }
    }

    // Reset state on open. Default the amount field to the active due's total so
    // CS doesn't have to retype it — and so the auto-reset after an inline TDS
    // apply lands at the right number.
    useEffect(() => {
        if (open) {
            set_comment('');
            set_credits(active_due && active_due.total ? Number(active_due.total) : 0);
        }
    }, [open]);

    // When the parent refetches dues after an inline TDS apply, `active_due.total`
    // changes — re-default the amount field to the new total so the confirmation
    // matches the recomputed due_amount the backend will enforce.
    useEffect(() => {
        if (open && active_due && active_due.total !== undefined && active_due.total !== null) {
            set_credits(Number(active_due.total));
        }
    }, [active_due && active_due.total]);

    return (
        <Modal className="modal-dialog-centered" size="lg" isOpen={open} toggle={toggle}>
            <div className="modal-header  bg-gradient-white">
                <h4 className="modal-title" id="exampleModalLabel" style={{margin: 'auto'}}>Record Manual Payment</h4>
                {/* <span className="pull-right">{generate_badge("Store ID - " + store_id, "info")}</span> */}
                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={toggle}>
                  <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body  bg-gradient-secondary" >
                <div className="pl-lg-4">
                  <InlineTdsAdjuster
                      ref={tds_ref}
                      order={active_due}
                      store_info={store_info}
                      user_details={user_details}
                      has_pending_offline_payment={has_pending_offline_payment}
                      set_page_loader={set_page_loader}
                      on_preview={(p) => set_credits(p.total)}
                  />
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          Note
                        </label>
                        <Input value={comment} onChange={e => set_comment(e.target.value)} name="comment" className="form-control-alternative" id="credits_comment"  type="text" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address" >
                          Amount in {store_info && store_info.market && store_info.market == 'international' ? 'USD' : 'INR'}
                        </label>
                        <Input value={credits} onChange={e => set_credits(Number(e.target.value))} name="credits" className="form-control-alternative" id="credits_free"  type="number" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button color="primary" onClick={assign_credits}>Record Payment</Button>
                </div>
            </div>
        </Modal>
    );
}

const RecordFirstPayment =({open, toggle, store_info, fetch_store_info, set_show_find_by_email_modal}) => {

	const [option_selected, set_option_selected] = useState(false);
	const [first_payment_option, set_first_payment_option] = useState('transfer_from_org');

	const onClick_handleClose = () => {
		set_option_selected(false)
		set_first_payment_option('transfer_from_org')
	}

	useEffect(() => {
		if(option_selected && first_payment_option === 'transfer_from_org'){
			set_show_find_by_email_modal(true)
			toggle()
			onClick_handleClose()
		}
	}, [option_selected, first_payment_option]);

	return(
		<Modal className="modal-dialog-centered" size="lg" isOpen={open} toggle={toggle}>
			<div className="modal-header  bg-gradient-white">
					<h4 className="modal-title" id="exampleModalLabel" style={{margin: 'auto'}}>Transfer Payment from another Org</h4>
					<span className="pull-right">{generate_badge("Store ID - " + (store_info ? store_info.id : ''), "info")}</span>
					<button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={toggle}>
					<span aria-hidden={true}>×</span>
					</button>
				</div>
				<div className="modal-body  bg-gradient-secondary" style={{fontSize:'14px'}}>
				{
					option_selected ? 
					<div>

					</div> 
					:
					<div style={{paddingLeft:'20px'}} onChange={(e) => set_first_payment_option(e.target.value)}>
						{/* <div className="flex_property mb-3" style={{justifyContent:'flex-start'}}>
							<Input value='new_entry' checked={first_payment_option === 'new_entry' ? true : false} style={{position:'unset', margin:'0px 10px 0px 0px'}} name='first_payment_option' type='radio'></Input>
							<span>New Entry</span>
						</div> */}
						<div className="flex_property" style={{justifyContent:'flex-start'}}>
							<Input value='transfer_from_org' checked={first_payment_option === 'transfer_from_org' ? true : false} style={{position:'unset', margin:'0px 10px 0px 0px'}} name='first_payment_option' type='radio'></Input>
							<span>Transfer from another Org</span>
						</div>
					</div>
				}
				</div>
				<div className="modal-footer" style={{height:'60px'}}> 
					{option_selected ? <Button className='white_button' onClick={() => set_option_selected(false)}>Back</Button> : ''}
					<Button color='primary' onClick={() => set_option_selected(true)}>Next</Button>
				</div>
		</Modal>
	)
}

const ExtendDueDate = ({open, toggle, due_date, store_id, order_id, fetch_dues}) => {

	const [selected_date, set_selected_date] = useState('');

	const onClick_handleClose = () => {
		set_selected_date('')
		toggle()
	}

	const onChangeDate = (date, dateString) => {
		console.log('dateString', dateString)
		set_selected_date(dateString)
	}

	const handle_submit = async() => {
		try{
			if(selected_date){
				let resp = await general_fetch({url:'csp/extend_due_date', body:{new_due_date: selected_date, customer_store_id: store_id, order_id}})
				onClick_handleClose()
				toastr.success('Due date extended successfully')
				fetch_dues()
			}else{
				toastr.error('Please select a date')
			}
		}catch(err){
			console.error(err)
			toastr.error(`Couldn't extend due date`)
		}
	}

	return(
		<Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onClick_handleClose}>
			<div className="modal-header  bg-gradient-white">
				<h4 className="modal-title" style={{}}>Extend Due Date</h4>
				<button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={onClick_handleClose}>
				<span aria-hidden={true}>×</span>
				</button>
			</div>
			<div className="modal-body  bg-gradient-secondary" style={{fontSize:'14px'}}>
				<DatePicker
					format="YYYY-MM-DD"
					disabledDate={(d) => new Date(d) <= new Date(due_date)}
					defaultValue = {due_date ? dayjs(due_date, 'YYYY-MM-DD') : null}
					onChange={onChangeDate}
				/>
			</div>
			<div className="modal-footer" style={{height:'60px'}}> 
				<Button className='white_button' onClick={onClick_handleClose}>Close</Button>
				<Button color='primary' onClick={() => {handle_submit()}}>Submit</Button>
			</div>
		</Modal>
	)
}


// Backend refusals of csp/credit_note/add_credit_note that are CS input mistakes (routes/credit_note.js
// CREDIT_NOTE_INPUT_ERRORS). Registered codes arrive as resp.code with a CS-readable resp.message; the
// unregistered ones arrive as code BAD_REQUEST with the bare token in resp.message, so both are mapped here.
const CREDIT_NOTE_ERROR_MESSAGES = {
	CREDIT_NOTE_SETTLES_DUE_CONFIRMATION_REQUIRED: 'This credit note would settle the live due and close its payment cycle; confirm to proceed',
	CREDIT_NOTE_BELOW_ABSOLUTE_DISCOUNT: 'This credit note would price the due below the absolute discount on it; reduce the note or remove the discount first',
	CREDIT_NOTE_BELOW_ABSOLUTE_TDS: 'This credit note would price the due below the absolute TDS on it; reduce the note or the TDS first',
	CREDIT_NOTE_REASON_REQUIRED: 'A note (reason) is required for a credit note',
	CREDIT_NOTE_ORDER_NOT_DUE: 'The selected order is no longer a live due; refresh the dues and try again',
	CREDIT_NOTE_REQUIRES_PREMIUM_ORG: 'Credit notes can only be issued to premium organisations',
	CREDIT_NOTE_REPRICE_REQUIRED: 'The live due could not be repriced for this note',
	CREDIT_NOTE_DUE_HAS_NO_CREDITS: 'The live due carries no credit line to apply the note to',
	TOO_MUCH_DISCOUNT: 'The note would exceed what the due can be discounted by',
	TOO_MUCH_TDS: 'The note would exceed what the due can carry after TDS',
}
const credit_note_error_of = (e) => {
	const resp = e && e.resp ? e.resp : null
	const code = resp && resp.code ? String(resp.code) : ''
	const message = resp && resp.message ? String(resp.message) : ''
	const token = CREDIT_NOTE_ERROR_MESSAGES[code] ? code : (CREDIT_NOTE_ERROR_MESSAGES[message] ? message : '')
	return {token, text: token ? (code === token && message && message !== token ? message : CREDIT_NOTE_ERROR_MESSAGES[token]) : ''}
}

const CreditNoteModal = ({open, toggle, get_credit_notes, store_id, store_info, set_page_loader, fetch_dues, order_id}) => {

	const [credits, set_credits] = useState('');
	const [note, set_note] = useState();
	const [show_grace_selection_ui, set_show_grace_selection_ui] = useState(false);
	const today = new Date()
	const tomorrow = new Date()
	tomorrow.setDate(today.getDate() + 1);
	const [from_date, set_from_date] = useState();
	const [to_date, set_to_date] = useState();
	const [ amount, set_amount ] = useState('');

	const onclick_handleclose = () => {
		toggle()
		set_credits('')
		set_amount('')
		set_note('')
		set_from_date()
		set_to_date()
		set_show_grace_selection_ui(false)
	}

	// confirm_settles_due is sent only after CS confirmed the backend's
	// CREDIT_NOTE_SETTLES_DUE_CONFIRMATION_REQUIRED answer; order_id pins the note to the due CS is
	// looking at, so a retry after the due settled is refused instead of credited to the balance.
	const submit_fn = async(confirm_arg) => {
		// The Submit button passes its click event as the first argument; only an explicit `true`
		// (from the confirm dialog's callback) counts as a confirmation.
		const confirm_settles_due = confirm_arg === true
		try {
			let body = {customer_store_id:store_id, type: show_grace_selection_ui?'Grace':'Overage', note }
			if(show_grace_selection_ui){
				body['start_date'] = new Date(from_date).toDateString()
				body['end_date'] = new Date(to_date).toDateString()
			}else{
				body['credits'] = Number(credits)
			}
			if(order_id) body['order_id'] = order_id
			if(confirm_settles_due) body['confirm_settles_due'] = true
			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({url:'csp/credit_note/add_credit_note', body})
			set_page_loader(false)
			toastr.success(confirm_settles_due ? 'Credit note added; the due is settled' : 'Successfully added credit note')
			get_credit_notes()
			onclick_handleclose()
			fetch_dues()
		}catch (e) {
			set_page_loader(false)
			console.error(e)
			const {token, text} = credit_note_error_of(e)
			if(token === 'CREDIT_NOTE_SETTLES_DUE_CONFIRMATION_REQUIRED'){
				submit(() => submit_fn(true), () => {}, text, 'Settle the due', '')
			}else if(token){
				toastr.error(text)
			}else{
				toastr.error(`Couldn't add Credit Note`)
			}
		}
	}

	const get_tentative_credits_for_duration = async(from_date, to_date) => {
		try {
			let body = {start_date: new Date(from_date).toDateString(), end_date: new Date(to_date).toDateString(), customer_store_id:store_id}
			set_page_loader(true, 'Calculating no.of credits...')
			let resp = await general_fetch({url:'csp/credit_note/get_tentative_credits_for_duration', body})
			set_page_loader(false)
			set_credits(resp)
		}catch (e) {
			set_page_loader(false)
			console.error(e)
		}
	}

	const onChangeFromDate = (date, dateString) => {
		set_from_date(dateString)
		document.getElementById('to_date').click()
	}

	const onChangeToDate = (date, dateString) => {
		set_to_date(dateString)
		get_tentative_credits_for_duration(from_date, dateString)
	}

	useEffect(() => {
		if(amount === 0) set_amount('')
		if(credits === 0) set_credits('')
	}, [amount, credits]);

	return(
		<CspModal open={open} toggle={onclick_handleclose} >
			{/* <GraceSelectionModal open={show_grace_selection_ui} toggle={() => set_show_grace_selection_ui(false)} set_credits={set_credits} store_id={store_id} set_page_loader={set_page_loader}/> */}
			<CspModalHeader title={'Add Credit Note'} toggle={onclick_handleclose}/>
			<CspModalBody style={{maxHeight:'600px'}}>
				<div className="flex_property" style={{alignItems:"base"}}>
					<FormGroup>
						<label className="form-control-label" htmlFor="input-address" >
							{show_grace_selection_ui ? 'Select dates for credits equivalent to days of usage' : `Amount (${store_info && store_info.ccr_details ? store_info.ccr_details.currency : ''}) or Credits`}
						</label>
						<div className="flex_property">
						{
							show_grace_selection_ui ? 
							<Row className=''>
								<Col md="6">
									<FormGroup className='flex_property mb-0'>
										<label className="form-control-label mr-2" htmlFor="input-address" >
											From
										</label>
										<DatePicker
											format="YYYY-MM-DD"
											onChange = {onChangeFromDate}
											// defaultValue = {from_date}
											// disabledDate={(d) => new Date(d) < new Date(today)}
										/>
									</FormGroup>
								</Col>
								<Col md="6">
									<FormGroup className='flex_property mb-0'>
										<label className="form-control-label mr-2" htmlFor="input-address" >
											To
										</label>
										<DatePicker
											id = 'to_date'
											format="YYYY-MM-DD"
											onChange = {onChangeToDate}
											// defaultValue={to_date}
											disabledDate={(d) => new Date(d) < new Date(from_date)}
										/>
									</FormGroup>
								</Col>
							</Row>
							:
							<Input value={amount} onChange={e => {set_credits((Number(e.target.value)/Number(store_info && store_info.ccr_details ? store_info.ccr_details.cost_per_credit : 1)).toFixed(2)); set_amount(e.target.value)}} className="form-control-alternative" type="number" style={{minWidth:'240px'}} placeholder={`Enter Amount (${store_info && store_info.ccr_details ? store_info.ccr_details.currency : ''})`} />
						}
						{
							!show_grace_selection_ui?
							<>
								<div className="mx-2">or</div>
								<div>
									<Input value={credits} onChange={e => {set_credits(e.target.value); set_amount((Number(e.target.value)*Number(store_info && store_info.ccr_details ? store_info.ccr_details.cost_per_credit : 1)).toFixed(2))}} className="form-control-alternative" type="number" style={{minWidth:'240px'}} placeholder='Enter Credits' />
								</div>
							</>:''
						}
							<div className="mx-2">or</div>
							<Button color='primary' onClick={() => {set_credits('');set_amount(''); set_show_grace_selection_ui(!show_grace_selection_ui)}}>{show_grace_selection_ui ? 'Enter No.of credits' : 'Select dates for credits'}</Button>
						</div>
						<div style={{fontSize:'14px'}} className="mt-2">
							{show_grace_selection_ui?<span className="mr-2" style={{fontWeight:700}}>Equivalent Amount - {(credits*(store_info && store_info.ccr_details ? store_info.ccr_details.cost_per_credit : 1)).toFixed(2)} ({store_info && store_info.ccr_details ? store_info.ccr_details.currency : ''}),</span>:''}
							Equivalent Credits - {credits}
						</div>
					</FormGroup>
				</div>
				<FormGroup>
					<label className="form-control-label" htmlFor="input-address" >
						Note
					</label>
					<textarea style={{height:'100px', width:'100%', borderRadius:'6px', border:'1px solid #cad1d7', fontSize:'14px'}} className='px-2 py-1' value={note} onChange={(e) => set_note(e.target.value)} placeholder='Type...'/>
				</FormGroup>
			</CspModalBody>
			<CspModalFooter>
				<Button color="primary" onClick={submit_fn}>Submit</Button>
			</CspModalFooter>
		</CspModal>
	)
}
  

const RejectOfflinePaymentModalDues = ({ open, toggle, payment, on_submit, submitting }) => {
	const [reason, set_reason] = useState('');

	useEffect(() => {
		if (!open) set_reason('');
	}, [open]);

	const handle_submit = () => {
		if (!reason.trim()) {
			toastr.error('Please provide a reason for rejection');
			return;
		}
		on_submit(reason.trim());
	};

	const formatted_amount = payment ? (payment.currency === 'USD' ? '$' : '₹') + Number(payment.amount || 0).toLocaleString('en-IN') : '';

	return (
		<Modal isOpen={open} toggle={toggle} className="modal-dialog-centered" size="md">
			<ModalHeader toggle={toggle}>Reject Offline Payment</ModalHeader>
			<ModalBody style={{ fontSize: '14px' }}>
				{payment ? (
					<div className="mb-3" style={{ background: '#fafafa', padding: '10px 12px', borderRadius: '6px' }}>
						<div><b>Order:</b> {payment.order_id}</div>
						<div><b>Amount:</b> {formatted_amount}</div>
						<div><b>Mode:</b> {payment.payment_mode || '-'}{payment.payment_reference ? ` (Ref: ${payment.payment_reference})` : ''}</div>
					</div>
				) : null}
				<FormGroup>
					<label className="form-control-label">Reason for rejection <span style={{ color: '#ff4d4f' }}>*</span></label>
					<Input
						type="textarea"
						rows={4}
						placeholder="e.g. Amount mismatch, illegible proof, wrong account..."
						value={reason}
						onChange={(e) => set_reason(e.target.value)}
					/>
					<small className="text-muted">
						Rejecting will revert the order's due date to {payment && payment.original_due_date ? date_string(payment.original_due_date) : 'its original value'} and re-suspend the org if it was suspended before submission.
					</small>
				</FormGroup>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" size="sm" onClick={toggle} disabled={submitting}>Cancel</Button>
				<Button color="danger" size="sm" onClick={handle_submit} disabled={submitting || !reason.trim()}>
					{submitting ? 'Rejecting...' : 'Reject Payment'}
				</Button>
			</ModalFooter>
		</Modal>
	);
};

const PendingOfflinePaymentCard = ({ store_id, user_details, dues, fetch_dues, fetch_store_info, set_page_loader }) => {
	const [pending_payment, set_pending_payment] = useState(null);
	const [loading, set_loading] = useState(false);
	const [reject_modal_open, set_reject_modal_open] = useState(false);
	const [submitting_reject, set_submitting_reject] = useState(false);

	const due_order_ids = useMemo(() => {
		if (!Array.isArray(dues)) return [];
		return dues.map(d => d.id).filter(Boolean);
	}, [dues]);

	const fetch_pending = async () => {
		if (!store_id) return;
		try {
			set_loading(true);
			let resp = await general_fetch({ url: 'csp/get_pending_offline_payments', body: { customer_store_id: store_id } });
			let match = null;
			if (Array.isArray(resp) && resp.length) {
				if (due_order_ids.length) {
					match = resp.find(p => due_order_ids.includes(p.order_id)) || resp[0];
				} else {
					match = resp[0];
				}
			}
			set_pending_payment(match);
		} catch (err) {
			console.error('failed to fetch pending offline payment for store', err);
		} finally {
			set_loading(false);
		}
	};

	useEffect(() => {
		fetch_pending();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [store_id, due_order_ids.join(',')]);

	const can_action = user_details && user_details.role && user_details.role.store
		&& (user_details.role.store.includes('customer_success_admin') || user_details.role.store.includes('customer_success_executive'));

	if (!pending_payment) return null;

	const formatted_amount = (pending_payment.currency === 'USD' ? '$' : '₹') + Number(pending_payment.amount || 0).toLocaleString('en-IN');

	const confirm_payment = async () => {
		try {
			set_page_loader(true, 'Confirming payment...');
			await general_fetch({ url: 'csp/confirm_offline_payment', body: { payment_id: pending_payment.id } });
			set_page_loader(false);
			toastr.success('Offline payment confirmed');
			fetch_dues();
			fetch_store_info();
			fetch_pending();
		} catch (err) {
			set_page_loader(false);
			console.error('confirm_offline_payment failed', err);
			const msg = err && err.err && err.err.message ? err.err.message : '';
			if (msg.includes('ORDER_ALREADY_PAID')) {
				toastr.warning('Order was already paid via online payment. The pending submission has been cleared.');
				fetch_dues();
				fetch_store_info();
				fetch_pending();
			} else {
				toastr.error('Could not confirm the offline payment, please try again.');
			}
		}
	};

	const reject_payment = async (reason) => {
		try {
			set_submitting_reject(true);
			set_page_loader(true, 'Rejecting payment...');
			await general_fetch({ url: 'csp/reject_offline_payment', body: { payment_id: pending_payment.id, reason } });
			set_page_loader(false);
			set_submitting_reject(false);
			set_reject_modal_open(false);
			toastr.success('Offline payment rejected');
			fetch_dues();
			fetch_store_info();
			fetch_pending();
		} catch (err) {
			set_page_loader(false);
			set_submitting_reject(false);
			console.error('reject_offline_payment failed', err);
			toastr.error('Could not reject the offline payment, please try again.');
		}
	};

	return (
		<>
			<RejectOfflinePaymentModalDues
				open={reject_modal_open}
				toggle={() => set_reject_modal_open(false)}
				payment={pending_payment}
				on_submit={reject_payment}
				submitting={submitting_reject}
			/>
			<div className="p-2 mb-2" style={{ width: '100%' }}>
				<Card className="p-4 shadow" style={{ fontSize: '14px', borderLeft: '4px solid #1890ff' }}>
					<div className="mb-3 flex_property" style={{ justifyContent: 'space-between' }}>
						<div>
							<h3 className="mb-0">Offline Payment Submitted - Awaiting Review</h3>
							<div className="text-muted" style={{ fontSize: '12px' }}>
								Org has uploaded a bank-transfer / offline payment proof. Access has been temporarily restored.
							</div>
						</div>
						<Badge color="info" className="px-3 py-2" style={{ fontSize: '12px' }}>Under Review</Badge>
					</div>
					<Row className="mb-3">
						<Col md="3">
							<div className="text-muted" style={{ fontSize: '12px' }}>Amount</div>
							<div style={{ fontWeight: 700 }}>{formatted_amount}</div>
						</Col>
						<Col md="3">
							<div className="text-muted" style={{ fontSize: '12px' }}>Payment Mode</div>
							<div style={{ textTransform: 'uppercase' }}>{pending_payment.payment_mode || '-'}</div>
						</Col>
						<Col md="3">
							<div className="text-muted" style={{ fontSize: '12px' }}>UTR / Reference</div>
							<div>{pending_payment.payment_reference || <span className="text-muted">None</span>}</div>
						</Col>
						<Col md="3">
							<div className="text-muted" style={{ fontSize: '12px' }}>Submitted</div>
							<div>{pending_payment.created_at ? date_string(pending_payment.created_at) : '-'}</div>
						</Col>
					</Row>
					{pending_payment.original_due_date ? (
						<div className="mb-2" style={{ fontSize: '12px', color: '#8c8c8c' }}>
							<i className="fa fa-info-circle mr-1" />
							Rejecting will restore the original due date: <b>{date_string(pending_payment.original_due_date)}</b>
						</div>
					) : null}
					{pending_payment.comment ? (
						<div className="mb-2" style={{ fontSize: '13px' }}>
							<span className="text-muted">Client comment:</span> {pending_payment.comment}
						</div>
					) : null}
					<div className="flex_property mt-2" style={{ gap: '8px', flexWrap: 'wrap' }}>
						<Button
							color="secondary"
							outline
							size="sm"
							disabled={!pending_payment.proof_of_payment}
							onClick={() => pending_payment.proof_of_payment && window.open(pending_payment.proof_of_payment, '_blank', 'noopener,noreferrer')}
						>
							<i className="fa fa-file mr-1" /> View Proof
						</Button>
						{can_action ? (
							<>
								<Button
									color="success"
									size="sm"
									onClick={() => submit(
										confirm_payment,
										() => {},
										`Confirm offline payment of ${formatted_amount}? This will mark the order as paid.`,
										''
									)}
								>
									<i className="fa fa-check mr-1" /> Confirm Payment
								</Button>
								<Button
									color="danger"
									outline
									size="sm"
									onClick={() => set_reject_modal_open(true)}
								>
									<i className="fa fa-times mr-1" /> Reject Payment
								</Button>
							</>
						) : null}
					</div>
				</Card>
			</div>
		</>
	);
};

const Dues = ({store_id, store_info, fetch_store_info, user_details, dues, fetch_dues, set_page_loader}) => {
    // const [dues, set_dues] = useState([]);
    const [is_make_payment_open, set_is_make_payment_open] = useState(false);
    const [active_order_id, set_active_order_id] = useState('');
	const [show_first_payment_modal, set_show_first_payment_modal] = useState(false);
	const [show_extend_due_date_modal, set_show_extend_due_date_modal] = useState(false);
	const [show_find_by_email_modal, set_show_find_by_email_modal] = useState(false);
	const [editing_discount_json, set_editing_discount_json] = useState({});
	const [editing_discount_perc_json, set_editing_discount_perc_json] = useState({});
	const [show_update_extra_users_modal, set_show_update_extra_users_modal] = useState(false);
	const [ show_remove_onboarding_fee_modal, set_show_remove_onboarding_fee_modal ] = useState(false);
	const [active_due, set_active_due] = useState();
	const [show_credit_note_modal, set_show_credit_note_modal] = useState(false);
	const [credit_notes, set_credit_notes] = useState([]);
	const [show_account_statement_modal, set_show_account_statement_modal] = useState(false);
	const [show_edit_tds_modal, set_show_edit_tds_modal] = useState(false);
	// Cached "is there any pending offline payment for any of this org's dues?"
	// Used to gate the TDS pencil. Backend redundantly enforces the same rule.
	const [has_pending_offline_payment, set_has_pending_offline_payment] = useState(false);
	// Opened instead of calling get_zoho_estimate when the org has no zoho
	// contact id — the modal resolves one from the org's GST first.
	const [show_zoho_details_modal, set_show_zoho_details_modal] = useState(false);
	const [zoho_pending_order_id, set_zoho_pending_order_id] = useState('');
	// The other half of the same gate: the org HAS a contact id, but its GST and
	// Zoho's disagree. Opened only when derive_mismatch_state says so; every other
	// outcome falls through to a plain download.
	const [show_gst_mismatch_modal, set_show_gst_mismatch_modal] = useState(false);
	const [gst_mismatch, set_gst_mismatch] = useState(null);
	// [ST-4040] the real reminder send unlocks only after a dry run of the same due
	const [dues_reminder_dry_run_order_id, set_dues_reminder_dry_run_order_id] = useState('');
	// [ST-3991] recalculating unlocks only after a dry run of the same due; holds its old/new totals
	const [recalculate_due_preview, set_recalculate_due_preview] = useState(null);

	// A dry run only vouches for the dues it was run on; any reload or org change needs a new one.
	useEffect(() => {
		set_recalculate_due_preview(null)
		set_dues_reminder_dry_run_order_id('')
	}, [store_id, dues]);

    const styles = {
        header_row: {
            marginLeft: 0,
        },
        table_header: {
            fontWeight: "bold",
            fontSize: 'small'
        },
        round_status: {
            fontSize: 'small',
            paddingBottom: 0
        },
        nav_pills_rounds: {
            paddingRight: 60,
            marginRight: "0.7rem",
            marginLeft: "0.2rem",
        },
        action_button: {
            margin: 1       
        }
    };

    const toggle = () => {set_is_make_payment_open(!is_make_payment_open)}

	const toggle_record_first_payment = () => {set_show_first_payment_modal(!show_first_payment_modal)}
	const toggle_update_extra_users = () => {set_show_update_extra_users_modal(!show_update_extra_users_modal)}
	const toggle_remove_onboarding_fee = () => {set_show_remove_onboarding_fee_modal(!show_remove_onboarding_fee_modal)}
	const toggle_extend_due_date = () => {set_show_extend_due_date_modal(!show_extend_due_date_modal)}

	const extend_due_date = async(due) => {
		try{
			let number_of_days = 0
			if(!due.extensions || (due.extensions.length == 0)){
				if(store_info.enterprise){
					number_of_days = 7
				}else{
					number_of_days = 3
				}
			}else if(due.extensions.length == 1){
				if(store_info.enterprise){
					number_of_days = 3
				}else{
					number_of_days = 1
				}
			}
			else{
				toastr.error(`You can't extend due date more than twice`)
				return
			}

			let resp = await general_fetch({url:'csp/extend_due_date', body:{order_id: due.id, number_of_days}}) 
			toastr.success('Successfully extended due date')
			fetch_store_info()
			fetch_dues()
		}catch(err){
			console.error("Could not extend due date")
		}
	}

	const send_dues_reminder = async (dry_run) => {
		try {
			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({url:'csp/send_dues_reminder', body:{customer_store_id: store_id, dry_run}, req_resp: true})
			set_page_loader(false, '')
			if (resp && resp.response_code === 1) {
				const sent = `${resp.data.template.replace('billing/', '')} (${resp.data.days_left} days left)`
				if (dry_run) {
					set_dues_reminder_dry_run_order_id(resp.data.order_id)
					toastr.success(`Dry run sent to ${resp.data.sent_to}: ${sent}`)
				} else {
					set_dues_reminder_dry_run_order_id('')
					toastr.success(`Sent ${sent}`)
				}
			} else {
				toastr.error(SEND_DUES_REMINDER_ERRORS[resp && resp.message] || (resp && resp.message) || 'Could not send the dues reminder')
			}
		} catch(err) {
			set_page_loader(false, '')
			console.error('send_dues_reminder failed', err)
			toastr.error('Could not send the dues reminder')
		}
	}

	const recalculate_due = async (dry_run) => {
		try {
			set_page_loader(true, dry_run ? 'Previewing the recalculated due...' : 'Recalculating the due...')
			// The real run names the due the dry run was for, so the backend refuses if it has changed since.
			let resp = await general_fetch({url:'csp/recalculate_due', body:{customer_store_id: store_id, dry_run, order_id: dry_run ? undefined : recalculate_due_preview.order_id}, req_resp: true})
			set_page_loader(false, '')
			if (resp && resp.response_code === 1) {
				const new_total = resp.data.new_due ? resp.data.new_due.total : 0
				if (dry_run) {
					set_recalculate_due_preview({order_id: resp.data.old_due.order_id, old_total: resp.data.old_due.total, new_total})
				} else {
					set_recalculate_due_preview(null)
					toastr.success(resp.data.new_due ? `Due recalculated: ${resp.data.old_due.total} → ${new_total}` : 'Due recalculated: nothing is due any more')
					fetch_store_info()
					fetch_dues()
				}
			} else {
				toastr.error(RECALCULATE_DUE_ERRORS[resp && resp.message] || (resp && resp.message) || 'Could not recalculate the due')
			}
		} catch(err) {
			set_page_loader(false, '')
			console.error('recalculate_due failed', err)
			toastr.error('Could not recalculate the due')
			// The backend may have committed before the response was lost; show what is there now.
			if (!dry_run) {
				fetch_store_info()
				fetch_dues()
			}
		}
	}

	const transfer_function = async(from_org, to_org_id) => {
		try{
			if(from_org && !from_org.premium_customer){
				toastr.error('Cannot transfer payment from a Non-premium Org')
				return
			}
			let resp = await general_fetch({url:'csp/migrate_first_payment_to_another_org', body:{from_org_id: from_org.id, to_org_id}, req_resp:true})
			if(resp.response_code == -1){
				toastr.error(resp.message)
			}else{				
				toastr.success('Successfully transfered payment')
				set_show_find_by_email_modal(false)
				fetch_store_info()
			}
		}catch(err){
			toastr.error('Tranfer Failed, Please make sure you have Customer Success Admin role')
			console.error(err)
		}
	}
	
	const update_editing_discount_json = (idx, val) => {
		let a = JSON.parse(JSON.stringify(editing_discount_json))
		a[idx] = val
		set_editing_discount_json(a)
	}

	const update_editing_discount_perc_json = (idx, val) => {
		let a = JSON.parse(JSON.stringify(editing_discount_perc_json))
		a[idx] = val
		set_editing_discount_perc_json(a)
	}

	const apply_discount_on_due = async(order_id, discount_input_id, type) => {
		try{
			let body = {order_id}
			if(type === 'perc'){
				body['discount_in_perc'] = Number(document.getElementById(discount_input_id).value)
			}else{
				body['abs_discount_in_money'] = Number(document.getElementById(discount_input_id).value)
			}
			let resp = await general_fetch({url:'csp/apply_discount_to_order ', body})
			fetch_dues()
			set_editing_discount_json({})
			set_editing_discount_perc_json({})
			toastr.success('Discount updated successfully')
		}catch(err){
			toastr.error('Could not update discount')
			console.log(err)
		}
	}

	const sort_by_created_at = (a,b) => {
		if(new Date(a.created_at) < new Date(b.created_at)) return 1
		return -1
	}

	const get_credit_notes = async() => {
		try {
			let resp = await general_fetch({url:'csp/credit_note/get_credit_notes', body:{customer_store_id:store_id}})
			if(resp && resp.length){
				resp.sort(sort_by_created_at)
			}
			set_credit_notes(resp)
		}catch(err){
			console.error(err)
		}
	}

	const remove_credit_note = async(credit_note_id) => {
		try {
			set_page_loader(true, 'Please wait...')
			await general_fetch({url:'csp/credit_note/remove', body:{customer_store_id:store_id, credit_note_id}})
			set_page_loader(false)
			toastr.success('Successfully removed credit note')
			get_credit_notes()
			fetch_dues()
		}catch(err){
			set_page_loader(false)
			console.error(err)
			toastr.error(`Couldn't remove Credit Note`)
		}
	}

	const convert_to_annual_renewal = async() => {
		try {
			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({url:'csp/convert_quarter_to_annual_renewal_payment', body:{customer_org_id:store_id}})
			set_page_loader(false)
			fetch_dues()
			toastr.success('Successfully converted to annual plan')
		}catch(err) {
			set_page_loader(false)
			console.error(err)
			toastr.error(`Couldn't convert to annual plan`)
		}
	}

	const convert_to_quarterly_renewal = async() => {
		try {
			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({url:'csp/convert_annual_to_quarter_renewal_payment', body:{customer_org_id:store_id}})
			set_page_loader(false)
			fetch_dues()
			toastr.success('Successfully converted to quarterly plan')
		}catch(err) {
			set_page_loader(false)
			console.error(err)
			toastr.error(`Couldn't convert to quarterly plan`)
		}
	}

	const change_payment_gateway = async (order_id, payment_gateway) => {
		try {
			set_page_loader(true, 'Please wait...')
			await general_fetch({url:'billing/order/change_payment_gateway', body:{order_id, payment_gateway}})
			set_page_loader(false)
			fetch_dues()
			toastr.success('Successfully changed the Payment Gateway')
		}catch(error) {
			set_page_loader(false)
			console.error(error)
			// general_fetch already toasts the backend message for TOAST_ERROR responses; others (raw Stripe errors) carry their own message
			const resp = (error && error.resp) || {}
			if (resp.action !== 'TOAST_ERROR') toastr.error(resp.message || `Couldn't change Payment Gateway`)
		}
	}
	// Fetch the weekly Zoho contacts dump. Returns null on ANY failure — a missing or
	// unreachable dump must never stop a download that works today.
	const fetch_zoho_dump = async () => {
		try {
			const resp = await general_fetch({ url: 'csp/get_zoho_contacts_dump_url', body: {} })
			// Deliberately not general_fetch: this is a signed GCS URL on another origin,
			// and general_fetch would attach credentials and a JSON content-type, both of
			// which fail CORS preflight there.
			const dump_resp = await fetch(resp.url)
			if (!dump_resp.ok) throw new Error(`dump fetch failed with status ${dump_resp.status}`)
			// The dump's age would be worth showing, but csp/get_zoho_contacts_dump_url
			// returns only {url} — there is no generation timestamp to surface yet. The
			// modal therefore says "may be up to a week old" rather than naming a date.
			return { dump: await dump_resp.json() }
		} catch (err) {
			// ZOHO_CONTACTS_DUMP_NOT_AVAILABLE is the expected state until the weekly cron
			// is scheduled; anything else is a genuine failure. Both mean the same thing
			// here — nothing to compare against — so they differ only in log volume.
			if (is_dump_unavailable_error(err)) {
				console.log('zoho contacts dump has not been generated yet', err)
			} else {
				console.error('could not fetch zoho contacts dump', err)
			}
			return null
		}
	}

	// Two different Zoho problems can block a correct estimate, and they are mutually
	// exclusive, so this button routes between them:
	//   no contact id  -> resolve one from the org's GST (ZohoDetailsMissingModal)
	//   contact id, GSTs disagree -> reconcile the two (ZohoGstMismatchModal)
	//   anything else  -> download exactly as before
	const on_click_download_estimate = async (order_id) => {
		// Only the mismatch branch needs the dump, so an org with no contact id is
		// routed without paying for a fetch.
		if (!(store_info && store_info.zoho_contact_id)) {
			set_zoho_pending_order_id(order_id)
			set_show_zoho_details_modal(true)
			return
		}

		// The org has a contact id. Check for a GST mismatch, but never let that check
		// itself become a new way for the download to fail.
		let routed = null
		try {
			set_page_loader(true, 'Please wait...')
			const fetched = await fetch_zoho_dump()
			routed = derive_download_route({
				store_info,
				dump: fetched && fetched.dump,
				dump_unavailable: !fetched,
				market: market_of_store(store_info),
			})
		} catch (err) {
			console.error('gst mismatch check failed, proceeding with download', err)
		} finally {
			set_page_loader(false)
		}

		if (routed && routed.route === 'resolve_mismatch') {
			set_gst_mismatch(routed.mismatch)
			set_zoho_pending_order_id(order_id)
			set_show_gst_mismatch_modal(true)
			return
		}
		if (routed && routed.reason) console.log('gst mismatch check:', routed.reason)
		get_zoho_estimate(order_id)
	}

	// zoho_contact_id/gst_number arrive only from the modal. customer_store_id is
	// required by the backend whenever a contact id is sent.
	const get_zoho_estimate = async (order_id, { zoho_contact_id, gst_number } = {}) => {
		try {
			set_page_loader(true, 'Please wait...')
			const body = build_estimate_body(order_id, store_id, { zoho_contact_id, gst_number })
			let resp = await general_fetch({ url: 'billing/order/get_zoho_estimate', body })
			set_page_loader(false)
			if (zoho_contact_id) fetch_store_info()
			if (resp) {
				const blob = new Blob([new Uint8Array(resp.data)], { type: 'application/pdf' })
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = 'document.pdf';
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(url);
				document.body.removeChild(link);
			}
			toastr.success('Successfully downloaded PI')
		} catch (err) {
			set_page_loader(false)
			console.error(err)
			const msg = err && err.err && err.err.message ? err.err.message : ''
			if (msg.includes('ORDER_DOES_NOT_BELONG_TO_ORG')) {
				toastr.error('This due does not belong to the selected org, please refresh and try again.')
			} else if (msg.includes('ZOHO_CONTACT_NOT_FOUND')) {
				toastr.error('No Zoho contact is linked to this org, please contact the Accounts admin.')
			} else {
				toastr.error(`Couldn't download PI, please try again`)
			}
		}
	}

    useEffect(() => {
        if(store_id) get_credit_notes()
    }, [store_id]);

    // Lightweight fetch to know whether any of this org's dues currently has a
    // pending offline-payment proof. Drives the TDS pencil's disabled state.
    // Refetched whenever dues change (e.g. after recompute or after CS confirm/reject).
    const due_order_ids_str = (dues || []).map(d => d && d.id).filter(Boolean).join(',');
    useEffect(() => {
        if (!store_id) return;
        let cancelled = false;
        (async () => {
            try {
                const resp = await general_fetch({ url: 'csp/get_pending_offline_payments', body: { customer_store_id: store_id } });
                if (cancelled) return;
                set_has_pending_offline_payment(Array.isArray(resp) && resp.length > 0);
            } catch (err) {
                if (!cancelled) set_has_pending_offline_payment(false);
                console.error('failed to check pending offline payment for tds gating', err);
            }
        })();
        return () => { cancelled = true; };
    }, [store_id, due_order_ids_str]);

    return(
        <>
            <MakePayment
                open={is_make_payment_open}
                toggle={toggle}
                store_id={store_id}
                store_info={store_info}
                active_due={(dues && Array.isArray(dues)) ? dues.find(d => d && d.id === active_order_id) : null}
                user_details={user_details}
                has_pending_offline_payment={has_pending_offline_payment}
                fetch_dues={fetch_dues}
                set_page_loader={set_page_loader}
            />
            <EditTdsModal
                open={show_edit_tds_modal}
                toggle={() => set_show_edit_tds_modal(false)}
                due={dues && dues[0]}
                store_info={store_info}
                set_page_loader={set_page_loader}
                on_success={() => { fetch_dues(); if (typeof fetch_store_info === 'function') fetch_store_info(); }}
            />
            <ZohoDetailsMissingModal
                open={show_zoho_details_modal}
                toggle={() => set_show_zoho_details_modal(false)}
                store_info={store_info}
                on_confirm={({ zoho_contact_id, gst_number }) => {
                    set_show_zoho_details_modal(false)
                    get_zoho_estimate(zoho_pending_order_id, { zoho_contact_id, gst_number })
                }}
            />
            <ZohoGstMismatchModal
                open={show_gst_mismatch_modal}
                toggle={() => set_show_gst_mismatch_modal(false)}
                store_id={store_id}
                store_info={store_info}
                mismatch={gst_mismatch}
                order_id={zoho_pending_order_id}
                on_resolved={({ updated }) => {
                    set_show_gst_mismatch_modal(false)
                    // finalise_org_gst has already persisted the GST. Download WITHOUT
                    // gst_number/zoho_contact_id params: passing them arms a speculative
                    // write-then-rollback in get_zoho_estimate whose "previous" value is
                    // the pre-finalise GST, so a PDF failure would revert exactly what we
                    // just committed while Zoho kept the new value.
                    if (updated && typeof fetch_store_info === 'function') fetch_store_info()
                    get_zoho_estimate(zoho_pending_order_id)
                }}
                on_skip={() => {
                    set_show_gst_mismatch_modal(false)
                    get_zoho_estimate(zoho_pending_order_id)
                }}
            />
			<RecordFirstPayment
				open={show_first_payment_modal}
				toggle={toggle_record_first_payment} 
				store_info={store_info} 
				fetch_store_info={fetch_store_info}
				set_show_find_by_email_modal = {set_show_find_by_email_modal}	
			/>
			<UpdateExtraUsers 
				open={show_update_extra_users_modal} 
				toggle={toggle_update_extra_users} 
				store_info={store_info} 
				fetch_store_info={fetch_store_info}
				fetch_dues={fetch_dues}
				set_page_loader={set_page_loader}
			/>
			<RemoveOnboardingFeeModal 
				open={show_remove_onboarding_fee_modal} 
				toggle={toggle_remove_onboarding_fee} 
				store_id={store_id}
				store_info={store_info} 
				fetch_store_info={fetch_store_info}
				dues={dues}
				fetch_dues={fetch_dues}
				set_page_loader={set_page_loader}
			/>
			<FindOrgsByEmail
				open = {show_find_by_email_modal}
				toggle={() => set_show_find_by_email_modal(!show_find_by_email_modal)}
				action_name={'Transfer from this Org'}
				action_function={(single_org) => {transfer_function(single_org, store_id)}}
				show_confirmation={true}
			/>
			<ExtendDueDate 
				open = {show_extend_due_date_modal}
				toggle={toggle_extend_due_date}
				due_date={active_due ? active_due.due_date.substring(0, 10) : ''}
				store_id={store_id}
				order_id={active_due ? active_due.id : ''}
				fetch_dues={fetch_dues}
			/>
			<CreditNoteModal 
				open={show_credit_note_modal}
				toggle={() => set_show_credit_note_modal(false)}
				get_credit_notes = {get_credit_notes}
				store_id={store_id}
				store_info={store_info}
				set_page_loader={set_page_loader}
				fetch_dues={fetch_dues}
				order_id={active_due ? active_due.id : ''}
			/>
			<AccountStatementModal
				open={show_account_statement_modal}
				toggle={() => set_show_account_statement_modal(false)}
				store_id={store_id}
				store_info={store_info}
				set_page_loader={set_page_loader}
			/>
			<PendingOfflinePaymentCard
				store_id={store_id}
				user_details={user_details}
				dues={dues}
				fetch_dues={fetch_dues}
				fetch_store_info={fetch_store_info}
				set_page_loader={set_page_loader}
			/>
			{
				store_info && !store_info.premium_customer ?
				<div style={{width:'100%', justifyContent:'flex-end'}} className="flex_property">
					<div className="purple_border mb-3" onClick={toggle_record_first_payment}>Transfer Payment from another Org</div>
				</div>:""
			}
			{
				<div className="flex_property" style={{alignItems:"start", flexWrap:'wrap'}}>
					<div className={`order-xl-${store_info.country != 'IN' ? 3 : 1} col-xl-5 p-2 mb-2`}>
						<Card className="p-4 shadow" style={{fontSize:'14px'}}>
							<div className="mb-4 flex_property" style={{justifyContent:"space-between"}}>
								<h3 className="mb-0">Due Details</h3>
								{
									dues && dues.length?
									<div>
										<a href={global.config.payment_path+'?due_order_id='+(dues[0].id)} target="_blank"><Button className="btn-sm mr-2" color="primary" >Payment Link <i className="fas fa-external-link-alt ml-1"/></Button></a>
										<Button className="btn-sm" color="primary" onClick={() => {toggle(); set_active_order_id(dues[0].id)}}>Add Payment</Button>
									</div>:""
								}
							</div>
						{
							dues && dues.length?
							<>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Estimated Invoice</div>
									<div style={{flex:3}}><Button className="btn-sm" color='primary' onClick={() => {on_click_download_estimate(dues[0].id)}}>Download Estimated Invoice</Button></div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Total Months </div>
									<div style={{flex:3}}>{dues[0].total_months}{<Button className="btn-sm ml-2" color='primary' onClick={() => submit(dues[0].total_months==3 ? convert_to_annual_renewal : convert_to_quarterly_renewal, ()=>{}, `Are you certain about converting the renewal payment to the ${dues[0].total_months==3 ? 'Annual' : 'Quarterly'} price?`, '', '')}>{dues[0].total_months==3 ? 'Convert to Annual' : 'Convert to Quarterly'}</Button>}</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Price </div>
									<div style={{flex:3}}>{dues[0].price}</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Extra Users </div>
									<div style={{flex:3}}>
										<div className="flex_property">
											{dues[0].dues_details ? dues[0].dues_details.excess_users_count : '0'}
											<i className="fa fa-edit ml-3 cp" style={{fontSize:'18px', color:'#0078ff'}} onClick={toggle_update_extra_users}/>
										</div>
									</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Discount (%) </div>
									<div style={{flex:3}}>
										{
											dues[0].status === 'due' ?(
												editing_discount_perc_json[0]? 
												<div className="flex_property">
													<Input type='number' className='standard_input' id={'discount_input_perc'+0}/>
													<i className='fas fa-check mx-3 cp' style={{color:'#23C16B', fontSize:'18px'}} onClick={() => {apply_discount_on_due(dues[0].id, 'discount_input_perc'+0, 'perc')}}/>
													<i className='fa fa-times cp' style={{color:'#FF5247', fontSize:'18px'}} onClick={() => {update_editing_discount_perc_json(0, false)}}/>
												</div>
												:
												<div className="flex_property">
													{dues[0].discount ? dues[0].discount.percentage : '0'}% 
													<i className="fa fa-edit ml-3 cp" style={{fontSize:'18px', color:'#0078ff'}} onClick={() => {update_editing_discount_perc_json(0, true); update_editing_discount_json(0, false)}}/>
												</div>
											):<div>{dues[0].discount ? dues[0].discount.percentage : '0'}% </div>
										}
									</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Discount (ABS) </div>
									<div style={{flex:3}}>
										{
											dues[0].status === 'due' ?(
												editing_discount_json[0]? 
												<div className="flex_property">
													<Input type='number' className='standard_input' id={'discount_input'+0}/>
													<i className='fas fa-check mx-3 cp' style={{color:'#23C16B', fontSize:'18px'}} onClick={() => {apply_discount_on_due(dues[0].id, 'discount_input'+0, 'absolute')}}/>
													<i className='fa fa-times cp' style={{color:'#FF5247', fontSize:'18px'}} onClick={() => {update_editing_discount_json(0, false)}}/>
												</div>
												:
												<div className="flex_property">
													{dues[0].discount ? dues[0].discount.absolute : '0'} 
													<i className="fa fa-edit ml-3 cp" style={{fontSize:'18px', color:'#0078ff'}} onClick={() => {update_editing_discount_json(0, true); update_editing_discount_perc_json(0, false)}}/>
												</div>
											):<div>{dues[0].discount ? dues[0].discount.absolute : '0'} </div>
										}
									</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Due </div>
									<div style={{flex:3}}>
										{dues[0].price_after_discount_before_tax}
									</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Tax </div>
									<div style={{flex:3}}>
										{dues[0].tax}
									</div>
								</div>
								{
									// TDS row — India-only, postpaid (renewal/overage) only.
									// Hidden for international orgs and for non-postpaid order types.
									(store_info && store_info.country === 'IN' && dues[0].type === 'postpaid') ? (
										<div className="flex_center mb-4">
											<div style={{flex:2}}>
												TDS
												<AntTooltip
													title={
														<div style={{ fontSize: 12, lineHeight: 1.5 }}>
															<b>Tax Deducted at Source</b> — India-only.<br />
															The client withholds this amount and remits it to the
															Income Tax department on our behalf, paying us only the
															net Total. The withheld amount comes back to us via Form
															16A at the end of the financial year.
														</div>
													}
													placement="right"
													overlayStyle={{ maxWidth: 320 }}
												>
													<i
														className="fa fa-info-circle ml-1 cp"
														style={{ fontSize: '12px', color: '#8a8f99' }}
													/>
												</AntTooltip>
											</div>
											<div style={{flex:3}}>
												<div className="flex_property">
													<div>{dues[0].tds || 0} {Number(dues[0].tds_absolute) > 0 ? '(fixed)' : (derive_tds_percentage(dues[0]) > 0 ? `(${derive_tds_percentage(dues[0])}%)` : '')}</div>
													{
														user_details && user_details.role && user_details.role.store && user_details.role.store.length
															&& (user_details.role.store.includes('customer_success_admin') || user_details.role.store.includes('customer_success_executive')) ? (
															<i
																className={`fa fa-edit ml-3 ${has_pending_offline_payment ? '' : 'cp'}`}
																style={{
																	fontSize: '18px',
																	color: has_pending_offline_payment ? '#c0c4cc' : '#0078ff',
																	cursor: has_pending_offline_payment ? 'not-allowed' : 'pointer',
																}}
																title={has_pending_offline_payment
																	? 'Resolve the pending offline payment proof before editing TDS.'
																	: 'Edit TDS for this due'}
																onClick={() => {
																	if (has_pending_offline_payment) {
																		toastr.info('Resolve the pending offline payment proof before editing TDS.');
																		return;
																	}
																	set_show_edit_tds_modal(true);
																}}
															/>
														) : ''
													}
												</div>
											</div>
										</div>
									) : ''
								}
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Total </div>
									<div style={{flex:3}}>
										{dues[0].total}
									</div>
								</div>
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Due by </div>
									<div style={{flex:3}}>
										<div className="flex_property">
											<div>{date_string(dues[0].due_date)}</div>
											{
												user_details && user_details.role && user_details.role.store && user_details.role.store.length && user_details.role.store.includes("customer_success_admin")?
												<i className="fa fa-edit cp ml-2" style={{color:'#0078ff', fontSize:'18px'}} onClick={() => {toggle_extend_due_date(); set_active_due(dues[0])}}/>:''
											}
										</div>
									</div>
								</div>
								{
									dues[0].extensions && dues[0].extensions.length > 1 ? '':
									<div className="flex_center mb-4">
										<div style={{flex:2}}>Extend </div>
										<div style={{flex:3}}>
											<Button className="btn-sm" color="primary" onClick={() => {submit(() => extend_due_date(dues[0]), ()=>{}, 'Are you sure you want to extend the due date ?', '','')}}>Extend Due Date ({dues[0].extensions && dues[0].extensions.length == 1 ? (store_info && store_info.enterprise ? '3 days' : '1 day') : (store_info && store_info.enterprise ? '7 days' : '3 days') })</Button>
										</div>
									</div>
								}
								{
									dues[0].type === 'postpaid' && user_details && SEND_DUES_REMINDER_EMAILS.includes(user_details.email) ?
									<div className="flex_center mb-4">
										<div style={{flex:2}}>Reminder </div>
										<div style={{flex:3}}>
											<Button className="btn-sm" color="primary" onClick={() => send_dues_reminder(true)}>Dry Run (to me)</Button>
											<Button className="btn-sm" color="primary" disabled={dues_reminder_dry_run_order_id !== dues[0].id} title={dues_reminder_dry_run_order_id !== dues[0].id ? 'Do a dry run first' : ''} onClick={() => {submit(() => send_dues_reminder(false), ()=>{}, 'Send the dues reminder matching the days left to the org\'s account managers?', '','')}}>Send to Account Managers</Button>
										</div>
									</div> : ''
								}
								{
									dues[0].type === 'postpaid' && user_details && user_details.role && user_details.role.store && user_details.role.store.includes('customer_success_admin') ?
									<div className="flex_center mb-4">
										<div style={{flex:2}}>Recalculate </div>
										<div style={{flex:3}}>
											<Button className="btn-sm" color="primary" onClick={() => recalculate_due(true)}>Dry Run</Button>
											<Button className="btn-sm" color="primary" disabled={!recalculate_due_preview || recalculate_due_preview.order_id !== dues[0].id} title={!recalculate_due_preview || recalculate_due_preview.order_id !== dues[0].id ? 'Do a dry run first' : ''} onClick={() => {submit(() => recalculate_due(false), ()=>{}, `Delete this due and its bills and bill them again from current data? The due changes from ${recalculate_due_preview.old_total} to ${recalculate_due_preview.new_total}.`, '','')}}>Recalculate Due</Button>
											{recalculate_due_preview && recalculate_due_preview.order_id === dues[0].id ? <div style={{fontSize:'12px'}}>Dry run: {recalculate_due_preview.old_total} → {recalculate_due_preview.new_total}</div> : ''}
										</div>
									</div> : ''
								}
								<div className="flex_center mb-4">
									<div style={{flex:2}}>Add-ons considered for the next cycle </div> 
									<div style={{flex:3}}>
										<div>{dues[0].dues_details && dues[0].dues_details.add_ons && dues[0].dues_details.add_ons.length ? dues[0].dues_details.add_ons.reduce((final, x, idx) => final + x.name + (idx!= dues[0].dues_details.add_ons.length-1 ? ', ' : ''), '') : 'N/A'}</div>
										{dues[0].dues_details && dues[0].dues_details.add_ons && dues[0].dues_details.add_ons.length ?<Button className="btn-sm" color="primary" onClick={toggle_remove_onboarding_fee}>Remove Onboarding Fee</Button> : ''}
									</div>
								</div>
								<div className="flex_center">
									<div style={{flex:2}}>Payment Gateway </div>
									<div style={{flex:3}}>{dues[0].payment_gateway}{payment_gateway_options(store_info, dues[0]).map(option => <Button key={option.payment_gateway} className="btn-sm ml-2" color='primary' onClick={() => submit(() => change_payment_gateway(dues[0].id, option.payment_gateway), ()=>{}, 'Are you certain about changing the payment gateway?', '', '')}>{option.label}</Button>)}</div>
								</div>
							</>:<div style={{width:'100%', fontWeight:'800', fontSize:'16px'}} className="flex_center">There are no dues</div>
						}
						</Card>
					</div>
					<div className="order-xl-2 col-xl-7 p-2 mb-2">
						<Card className="p-4 shadow" style={{fontSize:'14px'}}>
							<div className="mb-4 flex_property" style={{justifyContent:"space-between"}}>
								<h3 className="mb-0">Credit Notes</h3>
								<div className="flex_property" style={{gap:'8px'}}>
									{can_view_account_statement(user_details) ? <Button className="btn-sm" color="secondary" outline onClick={() => {set_show_account_statement_modal(true)}}>Account Statement</Button> : ''}
									{user_details && user_details.role && user_details.role.store && user_details.role.store.length && user_details.role.store.includes("customer_success_admin") ? <Button className="btn-sm" color="primary" onClick={() => {set_show_credit_note_modal(true)}}>Add Credit Note</Button> : ''}
								</div>
							</div>
							{
								credit_notes && credit_notes.length ? credit_notes.map((credit_note, idx) => (
									<div key={credit_note.id} style={{display:'flex', position:'relative'}} className="mb-4">
										<div className="activity_type_div mr-4">
										{<i className={`far fa-credit-card`} />}
										</div>
										{(idx != credit_notes.length-1) ? <div className="vertical_line"></div>  : ''}
										<div className="activity_box flex_property" style={{fontSize:'13px'}}>
											<div style={{width:'100%'}}>
												<div className="flex_center" style={{justifyContent:'space-between', width:'100%'}}>
													<div>
														<div className="mb-2">Amount : <span style={{fontWeight:700}}>{(credit_note.credits*(store_info && store_info.ccr_details ? store_info.ccr_details.cost_per_credit : 1)).toFixed(2)} ({store_info && store_info.ccr_details ? store_info.ccr_details.currency : ''})</span> , Credits : <span style={{fontWeight:700}}>{credit_note.credits}</span></div>
														<div>Type: {credit_note.type} {credit_note.type==='Grace' ? <span>- credits equivalent to <span style={{fontWeight:700}}>{date_string(credit_note.start_date)}</span> to <span style={{fontWeight:700}}>{date_string(credit_note.end_date)}</span> days of usage</span> : ''}</div>
														{(credit_note.system_generated || credit_note.order_id || credit_note.reverses_credit_note_id) ? <div style={{opacity:'0.7'}}>
															{credit_note.system_generated ? <Badge color="info" className="mr-2">System</Badge> : ''}
															{credit_note.reverses_credit_note_id ? <span className="mr-2">Reverses note {credit_note.reverses_credit_note_id}</span> : ''}
															{credit_note.order_id ? <span>Applied to due {credit_note.order_id}</span> : ''}
														</div> : ''}
														{/* {credit_note.type==='Grace' ? <div>Grace from <span style={{fontWeight:700}}>{date_string(credit_note.start_date)}</span> to <span style={{fontWeight:700}}>{date_string(credit_note.end_date)}</span></div> : <div>Overage Credits : <span style={{fontWeight:700}}>{credit_note.credits}</span></div>} */}
													</div>
													<div className="flex_property">
														<div style={{opacity:'0.4'}}>
															{date_string(credit_note.updated_at)}
														</div>
														{credit_note.removable && user_details && user_details.role && user_details.role.store && user_details.role.store.length && (user_details.role.store.includes("customer_success_admin") || user_details.role.store.includes("customer_success_executive")) ?
															<i className="fa fa-trash cp ml-3" style={{color:'#fb6340'}} title="Remove credit note" onClick={() => submit(() => remove_credit_note(credit_note.id), ()=>{}, 'Are you sure you want to remove this credit note? This will reverse the discount applied to the associated bill.', 'Remove', '')}/>
														: ''}
													</div>
												</div>
												{credit_note.note && String(credit_note.note).trim() ? <div className="mt-2" style={{whiteSpace:'pre-wrap', wordBreak:'break-word'}}>Note: <span style={{fontWeight:700}}>{String(credit_note.note)}</span></div> : ''}
											</div>
										</div>
									</div>
								)):""
							}
						</Card>
					</div>
					{
						store_info.country != 'IN' ?
							<div className="order-xl-1 col-xl-5 p-2 mb-2">
								<Card className="p-4 shadow" style={{ fontSize: '14px' }}>
									<div className="mb-4 flex_property" style={{ justifyContent: "space-between" }}>
										<h3 className="mb-0">Stripe Info</h3>
										<img src="/stripe.png" height={'24px'} />
									</div>
									{
										store_info && store_info.stripe_customer_info ?
										<div>
											<div className="mb-2">{`Customer Id: ${store_info.stripe_customer_info.customer ? (store_info.stripe_customer_info.customer) : '-'}`}</div>
											<div className="mb-2">{`Reported Amount: ${store_info.stripe_customer_info.reported_amount !== undefined ? store_info.stripe_customer_info.reported_amount : '-'}`}</div>
											<div className="mb-2">{`Status: ${store_info.stripe_customer_info.status ? store_info.stripe_customer_info.status : '-'}`}</div>
											<div className="mb-2">{`Next Invoice date: ${store_info.stripe_customer_info.next_invoice_date ? date_string(store_info.stripe_customer_info.next_invoice_date) : '-'}`}</div>
										</div>
										:
										<div>Stripe Subsription Info not found</div>
									}
								</Card>
							</div>
							: ''
					}
				</div>
			}
      </>
    )
}

export default Dues